export const KPI_ENGLISH = {
  "datox.kpi.layout": "KPI layout",
  "datox.kpi.standard": "Standard",
  "datox.kpi.compact": "Compact",
  "datox.kpi.prominent": "Prominent",
  "datox.kpi.currencyFormat": "Currency",
  "datox.kpi.currency": "Currency code",
  "datox.kpi.unit": "Unit",
  "datox.kpi.notation": "Notation and scaling",
  "datox.kpi.thousands": "Thousands (K)",
  "datox.kpi.millions": "Millions (M)",
  "datox.kpi.billions": "Billions (B)",
  "datox.kpi.percentScale": "Percentage mode",
  "datox.kpi.points": "Points (0.25 → 0.25%)",
  "datox.kpi.ratio": "Ratio (0.25 → 25%)",
  "datox.kpi.target": "Target",
  "datox.kpi.targetValue": "Target value (source units)",
  "datox.kpi.targetHelp": "Use the same units as the source value, before percentage or K/M/B scaling. For a 50% ratio target, enter 0.5.",
  "datox.kpi.none": "None",
  "datox.kpi.bar": "Bar",
  "datox.kpi.ring": "Ring",
  "datox.kpi.actual": "Actual",
  "datox.kpi.progress": "Target completion",
  "datox.kpi.loading": "Loading KPI…",
  "datox.kpi.error": "Couldn't load the KPI",
  "datox.kpi.missing": "No data",
  "datox.kpi.invalid": "Check KPI display settings and enter a positive target",
  "datox.kpi.calculation": "Calculation mode",
  "datox.kpi.aggregation": "Aggregation",
  "datox.kpi.formula": "Formula",
  "datox.kpi.expression": "KPI formula",
  "datox.kpi.formulaHelp": "Use sum, avg, min, max, count(), safe_divide, round, abs or if_else. Wrap columns with spaces in backticks.",
  "datox.kpi.apply": "Apply formula",
  "datox.kpi.preview": "Result preview",
  "datox.kpi.unavailable": "Unavailable",
  "datox.kpi.explain": "Explain source",
  "datox.kpi.sourceRows": "Applicable rows: {count}",
  "datox.kpi.sourceDataset": "Source dataset: {name}",
  "datox.kpi.sourceColumns": "Referenced columns: {names}",
  "datox.kpi.sourceFilters": "Filters applied: {count}",
  "datox.kpi.sourceSort": "Sorted by: {column}",
  "datox.kpi.sourceLimit": "Row limit: {count}",
  "datox.kpi.sourceSubtitle": "Understand how this KPI is calculated",
  "datox.kpi.sourceResult": "Calculated result",
  "datox.kpi.sourceData": "Source dataset",
  "datox.kpi.sourceSelectedDataset": "Selected dataset",
  "datox.kpi.sourceFields": "Columns used in this calculation",
  "datox.kpi.sourceTechnical": "Show dataset ID",
  "datox.kpi.sourceConstraints": "Filters and limits",
  "datox.kpi.sourceNoConstraints": "All source rows are included. No filters or limits are applied.",
  "datox.kpi.sourceEvidence": "Source rows",
  "datox.kpi.sourceEvidenceHelp": "Showing {shown} of {total} applicable rows. The calculation uses all applicable rows.",
  "datox.kpi.sourceAllColumns": "Show all columns",
  "datox.kpi.sourceRelevantColumns": "Show calculation columns",
  "datox.kpi.sourceNoRows": "No source rows match the current filters and limits.",
  "datox.kpi.sourceClose": "Close",
  "datox.kpi.sourceRetry": "Try again",
  "datox.kpi.expression_required": "Enter a formula expression.",
  "datox.kpi.expression_too_long": "Keep the formula under 1,000 characters.",
  "datox.kpi.too_complex": "Simplify the formula (up to 100 parts and 20 nested levels).",
  "datox.kpi.unknown_column": "Unknown column: {column}. Check the source column names.",
  "datox.kpi.numeric_column_required": "Column {column} must contain numbers.",
  "datox.kpi.unsupported_function": "Unsupported function: {function}. Use a supported KPI function.",
  "datox.kpi.aggregate_arguments": "{function}() needs one column name.",
  "datox.kpi.function_arguments": "Check the arguments to {function}().",
  "datox.kpi.aggregate_required": "Reference columns inside sum(), avg(), min() or max().",
  "datox.kpi.round_digits": "round() needs a whole-number precision from 0 to 6.",
  "datox.kpi.invalid_expression": "Check the formula syntax and backticks.",
  "datox.kpi.invalid_calculation": "Use a version 1 KPI formula.",
  "datox.kpi.widget_id_required": "This KPI needs a widget ID before you can save a formula.",
  "datox.kpi.duplicate_widget_id": "Widget ID {widget} is used more than once. Give each widget a unique ID.",
  "datox.kpi.formula_widget_type": "Formulas are supported only on KPI widgets.",
  "datox.kpi.ambiguous_column": "Column alias {column} is ambiguous. Use the exact column name in backticks.",
  "datox.kpi.exportPreparing": "Preparing PDF: waiting for KPI results…",
  "datox.kpi.exportTimeout": "KPI results took too long to load. Check the connection and try exporting again.",
  "datox.kpi.exportFailed": "Couldn't export the dashboard. Resolve any KPI errors and try again.",
  "datox.kpi.unsupported_expression": "This expression or operator is not supported in KPI formulas.",
  "datox.kpi.builder": "Builder",
  "datox.kpi.expressionTab": "Expression",
  "datox.kpi.editorMode": "Formula editing method",
  "datox.kpi.startFrom": "Start from a calculation",
  "datox.kpi.chooseTemplate": "Choose a starting point…",
  "datox.kpi.ratioTemplate": "Ratio — divide safely",
  "datox.kpi.differenceTemplate": "Difference — subtract totals",
  "datox.kpi.conditionalTemplate": "Conditional — if / then / otherwise",
  "datox.kpi.countTemplate": "Count rows",
  "datox.kpi.undoFormula": "Undo formula edit",
  "datox.kpi.redoFormula": "Redo formula edit",
  "datox.kpi.completeBuilder": "Complete each field and enter valid numbers to preview this formula.",
  "datox.kpi.preservedExpression": "This expression is preserved. Use Expression mode to edit it, or simplify it before switching to the builder.",
  "datox.kpi.viewExpression": "View generated expression",
  "datox.kpi.insertFunction": "Functions & columns",
  "datox.kpi.completionHelp": "Press Ctrl+Space for functions and columns.",
  "datox.kpi.suggestions": "Formula suggestions",
  "datox.kpi.noSuggestions": "No matching functions or columns.",
  "datox.kpi.functionLabel": "Function",
  "datox.kpi.columnLabel": "Column",
  "datox.kpi.chooseColumn": "Choose a source column…",
  "datox.kpi.formulaTerm": "Formula term",
  "datox.kpi.valueType": "Value type",
  "datox.kpi.aggregateTerm": "Aggregate a column",
  "datox.kpi.numberTerm": "Number",
  "datox.kpi.operationTerm": "Arithmetic or comparison",
  "datox.kpi.logicTerm": "Combine conditions",
  "datox.kpi.literalTerm": "True, false or unavailable",
  "datox.kpi.unaryTerm": "Sign or negation",
  "datox.kpi.leftValue": "Left value",
  "datox.kpi.rightValue": "Right value",
  "datox.kpi.valueLabel": "Value",
  "datox.kpi.operator": "Operation",
  "datox.kpi.numerator": "Numerator",
  "datox.kpi.denominator": "Denominator",
  "datox.kpi.precision": "Decimal places (0–6)",
  "datox.kpi.condition": "Condition",
  "datox.kpi.thenValue": "Then",
  "datox.kpi.elseValue": "Otherwise",
  "datox.kpi.allConditions": "All conditions (and)",
  "datox.kpi.anyConditions": "Any condition (or)",
  "datox.kpi.true": "True",
  "datox.kpi.false": "False",
  "datox.kpi.resizeEditor": "Resize widget editor",
  "datox.kpi.resizeEditorHelp": "Drag to resize, or use Left/Right arrow keys. Double-click to reset.",
  "datox.kpi.function.sum": "Sum",
  "datox.kpi.function.avg": "Average",
  "datox.kpi.function.min": "Minimum",
  "datox.kpi.function.max": "Maximum",
  "datox.kpi.function.count": "Count rows",
  "datox.kpi.function.safe_divide": "Safe division",
  "datox.kpi.function.round": "Round",
  "datox.kpi.function.abs": "Absolute value",
  "datox.kpi.function.if_else": "If / then / otherwise",
  "datox.kpi.help.sum": "sum(column) — Total of the applicable numeric values.",
  "datox.kpi.help.avg": "avg(column) — Average of the applicable numeric values.",
  "datox.kpi.help.min": "min(column) — Smallest applicable numeric value.",
  "datox.kpi.help.max": "max(column) — Largest applicable numeric value.",
  "datox.kpi.help.count": "count() — Number of applicable rows; no column is required.",
  "datox.kpi.help.safe_divide": "safe_divide(numerator, denominator) — Unavailable when the denominator is zero.",
  "datox.kpi.help.round": "round(value, decimals) — Round a value to 0–6 decimal places.",
  "datox.kpi.help.abs": "abs(value) — Return the absolute value.",
  "datox.kpi.help.if_else": "if_else(condition, then_value, otherwise_value) — Evaluate only the selected branch.",
  "datox.kpi.operator.add": "Add (+)",
  "datox.kpi.operator.subtract": "Subtract (−)",
  "datox.kpi.operator.multiply": "Multiply (×)",
  "datox.kpi.operator.divide": "Divide (÷)",
  "datox.kpi.operator.gt": "Greater than (>)",
  "datox.kpi.operator.gte": "Greater than or equal (≥)",
  "datox.kpi.operator.lt": "Less than (<)",
  "datox.kpi.operator.lte": "Less than or equal (≤)",
  "datox.kpi.operator.eq": "Equal (==)",
  "datox.kpi.operator.neq": "Not equal (!=)",
  "datox.kpi.operator.not": "Not",
} as const

export function dashboardKpiLabels(t: (key: keyof typeof KPI_ENGLISH) => string) {
  return {
    layout: t("datox.kpi.layout"), standard: t("datox.kpi.standard"), compact: t("datox.kpi.compact"), prominent: t("datox.kpi.prominent"),
    currencyFormat: t("datox.kpi.currencyFormat"), currency: t("datox.kpi.currency"), unit: t("datox.kpi.unit"), notation: t("datox.kpi.notation"),
    thousands: t("datox.kpi.thousands"), millions: t("datox.kpi.millions"), billions: t("datox.kpi.billions"),
    percentScale: t("datox.kpi.percentScale"), points: t("datox.kpi.points"), ratio: t("datox.kpi.ratio"),
    target: t("datox.kpi.target"), targetValue: t("datox.kpi.targetValue"), targetHelp: t("datox.kpi.targetHelp"),
    none: t("datox.kpi.none"), bar: t("datox.kpi.bar"), ring: t("datox.kpi.ring"), actual: t("datox.kpi.actual"), progress: t("datox.kpi.progress"),
    loading: t("datox.kpi.loading"), error: t("datox.kpi.error"), missing: t("datox.kpi.missing"), invalid: t("datox.kpi.invalid"),
    calculation: t("datox.kpi.calculation"), aggregation: t("datox.kpi.aggregation"), formula: t("datox.kpi.formula"),
    expression: t("datox.kpi.expression"), formulaHelp: t("datox.kpi.formulaHelp"), apply: t("datox.kpi.apply"),
    preview: t("datox.kpi.preview"), unavailable: t("datox.kpi.unavailable"), explain: t("datox.kpi.explain"),
    sourceRows: t("datox.kpi.sourceRows"), sourceDataset: t("datox.kpi.sourceDataset"), sourceColumns: t("datox.kpi.sourceColumns"),
    sourceFilters: t("datox.kpi.sourceFilters"), sourceSort: t("datox.kpi.sourceSort"), sourceLimit: t("datox.kpi.sourceLimit"),
    sourceSubtitle: t("datox.kpi.sourceSubtitle"), sourceResult: t("datox.kpi.sourceResult"), sourceData: t("datox.kpi.sourceData"),
    sourceSelectedDataset: t("datox.kpi.sourceSelectedDataset"), sourceFields: t("datox.kpi.sourceFields"), sourceTechnical: t("datox.kpi.sourceTechnical"),
    sourceConstraints: t("datox.kpi.sourceConstraints"), sourceNoConstraints: t("datox.kpi.sourceNoConstraints"), sourceEvidence: t("datox.kpi.sourceEvidence"),
    sourceEvidenceHelp: t("datox.kpi.sourceEvidenceHelp"), sourceAllColumns: t("datox.kpi.sourceAllColumns"), sourceRelevantColumns: t("datox.kpi.sourceRelevantColumns"),
    sourceNoRows: t("datox.kpi.sourceNoRows"), sourceClose: t("datox.kpi.sourceClose"), sourceRetry: t("datox.kpi.sourceRetry"),
    exportPreparing: t("datox.kpi.exportPreparing"), exportTimeout: t("datox.kpi.exportTimeout"), exportFailed: t("datox.kpi.exportFailed"),
    errors: Object.fromEntries(["expression_required", "expression_too_long", "too_complex", "unknown_column", "numeric_column_required", "unsupported_function", "aggregate_arguments", "function_arguments", "aggregate_required", "round_digits", "invalid_expression", "invalid_calculation", "widget_id_required", "unsupported_expression", "duplicate_widget_id", "formula_widget_type", "ambiguous_column"].map((code) => [code, t(`datox.kpi.${code}` as keyof typeof KPI_ENGLISH)])),
    builder: t("datox.kpi.builder"), expressionTab: t("datox.kpi.expressionTab"), editorMode: t("datox.kpi.editorMode"),
    startFrom: t("datox.kpi.startFrom"), chooseTemplate: t("datox.kpi.chooseTemplate"), ratioTemplate: t("datox.kpi.ratioTemplate"),
    differenceTemplate: t("datox.kpi.differenceTemplate"), conditionalTemplate: t("datox.kpi.conditionalTemplate"), countTemplate: t("datox.kpi.countTemplate"),
    undoFormula: t("datox.kpi.undoFormula"), redoFormula: t("datox.kpi.redoFormula"), completeBuilder: t("datox.kpi.completeBuilder"),
    preservedExpression: t("datox.kpi.preservedExpression"), viewExpression: t("datox.kpi.viewExpression"), insertFunction: t("datox.kpi.insertFunction"),
    completionHelp: t("datox.kpi.completionHelp"), suggestions: t("datox.kpi.suggestions"), noSuggestions: t("datox.kpi.noSuggestions"),
    functionLabel: t("datox.kpi.functionLabel"), columnLabel: t("datox.kpi.columnLabel"), chooseColumn: t("datox.kpi.chooseColumn"),
    formulaTerm: t("datox.kpi.formulaTerm"), valueType: t("datox.kpi.valueType"), aggregateTerm: t("datox.kpi.aggregateTerm"),
    numberTerm: t("datox.kpi.numberTerm"), operationTerm: t("datox.kpi.operationTerm"), logicTerm: t("datox.kpi.logicTerm"),
    literalTerm: t("datox.kpi.literalTerm"), unaryTerm: t("datox.kpi.unaryTerm"), leftValue: t("datox.kpi.leftValue"), rightValue: t("datox.kpi.rightValue"),
    valueLabel: t("datox.kpi.valueLabel"), operator: t("datox.kpi.operator"), numerator: t("datox.kpi.numerator"), denominator: t("datox.kpi.denominator"),
    precision: t("datox.kpi.precision"), condition: t("datox.kpi.condition"), thenValue: t("datox.kpi.thenValue"), elseValue: t("datox.kpi.elseValue"),
    allConditions: t("datox.kpi.allConditions"), anyConditions: t("datox.kpi.anyConditions"),
    literals: { True: t("datox.kpi.true"), False: t("datox.kpi.false"), None: t("datox.kpi.unavailable") },
    resizeEditor: t("datox.kpi.resizeEditor"), resizeEditorHelp: t("datox.kpi.resizeEditorHelp"),
    functions: Object.fromEntries(["sum", "avg", "min", "max", "count", "safe_divide", "round", "abs", "if_else"].map((name) => [name, t(`datox.kpi.help.${name}` as keyof typeof KPI_ENGLISH)])),
    functionNames: Object.fromEntries(["sum", "avg", "min", "max", "count", "safe_divide", "round", "abs", "if_else"].map((name) => [name, t(`datox.kpi.function.${name}` as keyof typeof KPI_ENGLISH)])),
    operators: { "+": t("datox.kpi.operator.add"), "-": t("datox.kpi.operator.subtract"), "*": t("datox.kpi.operator.multiply"), "/": t("datox.kpi.operator.divide"),
      ">": t("datox.kpi.operator.gt"), ">=": t("datox.kpi.operator.gte"), "<": t("datox.kpi.operator.lt"), "<=": t("datox.kpi.operator.lte"),
      "==": t("datox.kpi.operator.eq"), "!=": t("datox.kpi.operator.neq"), not: t("datox.kpi.operator.not") },
  }
}
